import { Result } from "@lib/result";
import {
	httpClient,
	getApplicationHeaders,
	UserTypes,
	getAgencyKey,
} from "@utils";

export default class DataConfirmationService {
	static GetRequestHeaders = (owner = UserTypes.PRIMARY) => {
		const appHeaders = getApplicationHeaders(owner);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async AcceptUserDataConfirmation(): Promise<boolean> {
		try {
			const url = `${WEBPACK_BASE_ADDRESS}${getAgencyKey()}/user-data-confirmations/confirm-user`;
			await httpClient.post(url, null, this.GetRequestHeaders());

			return true;
		} catch (error) {
			console.error(error);
			return false;
		}
	}

	static async FetchCountryLookups(): Promise<
		Result<CountryLookupsResponse, any>
	> {
		const url = `${WEBPACK_BASE_ADDRESS}platform/countries?sort=name|asc&fields=id,name&rpp=1000&translate=true`;
		try {
			const response = await httpClient.get(
				url,
				this.GetRequestHeaders(),
				{
					responseType: "json",
				}
			);
			return new Result(response, null);
		} catch (error) {
			return new Result<CountryLookupsResponse, any>(null, error);
		}
	}
}

export type CountryLookupsResponse = {
	embed?: string | null;
	searchQuery?: string | null;
	sort?: string;

	item: CountryLookup[];
	links: any[]; // TODO

	page: number;
	recordsPerPage: number;
	totalRecord: number;
};

export type CountryLookup = {
	id: string; // TODO
	name: string; // TODO
};
